'use strict';

var robust = require('../util/robust');
var toggle = require('../modules/toggle');
var spotlight = require('../modules/spotlight');
var accordion = require('../modules/accordion');
var videoResize = require('../modules/videoResize');
var calendar = require('../modules/calendar');
var textareaResize = require('../modules/textareaResize');
var scrollFader = require('../modules/scrollFader')
var personalisation = require('../modules/personalisation');
var welcomeMessage = require('../modules/welcomeMessage');
var tracking = require('../modules/tracking');
var messages = require('../modules/messages');
var inlineGallery = require('../modules/inlineGallery');
var dragscroll = require('../modules/dragscroll');
var castCreative = require('../modules/castCreative');
var toggleClass = require('../modules/toggleClass');
var autoSelect = require('../modules/autoSelect');
var fancyRange = require('../modules/fancyRange');
var logout = require('../modules/logout');
var nfscroll = require('../modules/nfscroll');
var productionHeader = require('../modules/productionHeader');
// var angularRangeSlider = require('../modules/angular-range-slider');

function init() {
    robust
        .defineModules([
            ['toggle', toggle.init],
            ['spotlight', spotlight.init],
            ['accordion', accordion.init],
            ['videoResize', videoResize.init],
            ['calendar', calendar.init],
            ['textareaResize', textareaResize.init],
            ['scrollFader', scrollFader.init],
            ['personalisation', personalisation.init],
            ['welcomeMessage', welcomeMessage.init],
            ['tracking', tracking.init],
            ['inlineGallery', inlineGallery.init],
            ['messages', messages.init],
            ['dragscroll', dragscroll.init],
            ['castCreative', castCreative.init],
            ['toggleClass', toggleClass.init],
            ['autoSelect', autoSelect.init],
            ['fancyRange', fancyRange.init],
            ['logout', logout.init],
            ['nfscroll', nfscroll.init],
            ['productionHeader', productionHeader.init],
        ])
        .forEach(function (fn) {
            fn();
        });
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./bootstraps/common.js